import { render, staticRenderFns } from "./AccountingPeriodsView.vue?vue&type=template&id=3975e8a9&scoped=true"
import script from "./AccountingPeriodsView.vue?vue&type=script&lang=js"
export * from "./AccountingPeriodsView.vue?vue&type=script&lang=js"
import style0 from "./AccountingPeriodsView.vue?vue&type=style&index=0&id=3975e8a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3975e8a9",
  null
  
)

export default component.exports